import {
	collectIntakeChannelErrors,
	createIntakeChannelDraft,
	intakeChannelDraftToEntry,
	intakeChannelEntryToDraft,
	sanitizeIntakeChannelDraft,
	type IntakeChannelDraft,
} from '#app/routes/mocra+/_form+/adverse-events/components/intake-channels/types.ts'
import {
	ComplaintChannelSchema,
	type ComplaintChannelEntry,
} from '#app/routes/mocra+/_form+/adverse-events/form.ts'
import { CHANNEL_CARD_OPTIONS } from '#app/routes/mocra+/_form+/adverse-events/helpers.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const intakeChannelDefinition = assertEntityDefinition<
	ComplaintChannelEntry,
	IntakeChannelDraft
>({
	schema: ComplaintChannelSchema,
	createDraft: () =>
		createIntakeChannelDraft(CHANNEL_CARD_OPTIONS[0]?.value ?? 'hotline'),
	sanitizeDraft: sanitizeIntakeChannelDraft,
	serialize: intakeChannelDraftToEntry,
	deserialize: intakeChannelEntryToDraft,
	collectErrors: collectIntakeChannelErrors,
})

export type IntakeChannelEntityDraft = IntakeChannelDraft
